const CURRENCY_SYMBOLS: Record<string, string> = {
  EUR: '\u20ac',
  USD: '$',
  UAH: '\u20b4',
  GBP: '\u00a3',
  PLN: 'z\u0142',
  KZT: '\u20b8',
  // The dirham's own sign is Arabic (\u062f.\u0625) and right-to-left, which reverses the
  // amount beside it and does not render in the invoice PDF's font. UAE invoices
  // in international trade are written "AED 1,000.00" anyway.
  AED: 'AED',
};

export const getCurrencySymbol = (currency: string): string => {
  return CURRENCY_SYMBOLS[currency] || currency;
};

export const formatCurrency = (amount: number, currency: string = 'EUR'): string => {
  const symbol = getCurrencySymbol(currency);
  const abs = Math.abs(amount);
  const [whole, dec] = abs.toFixed(2).split('.');
  const formatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '\u2009');
  return `${amount < 0 ? '-' : ''}${symbol}\u2009${formatted}.${dec}`;
};

export const formatCurrencyNumber = (num: number): string => {
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/**
 * Compact formatting for summary cards where cents become noise.
 *   < 1 000          -> full with cents     (€123.45)
 *   1 000 .. 999 999 -> 1 decimal "k"       (€10.5k)
 *   >= 1 000 000     -> 1 decimal "M"       (€4.4M)
 *
 * Keep formatCurrency for detail/report layers where exact amount matters.
 */
export const formatCurrencyShort = (amount: number, currency: string = 'EUR'): string => {
  const symbol = getCurrencySymbol(currency);
  const abs = Math.abs(amount);
  const sign = amount < 0 ? '-' : '';

  if (abs >= 1_000_000) {
    return `${sign}${symbol} ${(abs / 1_000_000).toFixed(1)}M`;
  }
  if (abs >= 1_000) {
    return `${sign}${symbol} ${(abs / 1_000).toFixed(1)}k`;
  }
  // Under 1k — keep cents (full format).
  const [whole, dec] = abs.toFixed(2).split('.');
  const formatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${sign}${symbol} ${formatted}.${dec}`;
};
